import { render } from "./HSSearchSuggestionSelect.vue?vue&type=template&id=9297ad54&scoped=true"
import script from "./HSSearchSuggestionSelect.vue?vue&type=script&lang=js"
export * from "./HSSearchSuggestionSelect.vue?vue&type=script&lang=js"

import "./HSSearchSuggestionSelect.vue?vue&type=style&index=0&id=9297ad54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9297ad54"]])

export default __exports__